/**
 * @module imports/auth
 */
import { canUseDOM } from 'exenv'

/**
 * if token exist in user object it will set user object to storage
 * @param  {Object} user user object that contain token
 */
export function login(user) {
    if (!canUseDOM) {
        return;
    }

    if (user && user.token && user.token.length > 0) {
        localStorage.setItem('user', JSON.stringify(user));
    }
}
/**
 * it will remove user storage
 */
export function logout() {
    if (!canUseDOM) {
        return;
    }
    localStorage.removeItem('user');
}

/**
 * get user object from storage
 */
export function getUser() {
    if (!canUseDOM) {
        return null;
    }
    return JSON.parse(localStorage.getItem('user'));
}

/**
 * check user exist and have token 
 */
export function isLogin() {
    if (!canUseDOM) {
        return false;
    }
    let user = getUser();
    return (user && user.token && user.token.length > 0);
}